import { Components } from '@mui/material';

export const pagination: Components = {
  MuiPaginationItem: {
    styleOverrides: {
      root: {
        paddingTop: '1px',
      },
    },
  },
};
